import { useDebounceFn } from 'ahooks';
import { Flex, Input, Select } from 'antd';
import { FC } from 'react';
import { useOrderByKey, useSetOrderBy, useSetSearchQuery } from '../../../store/filepicker.store';

type FiltersProps = {
  isFetching: boolean;
};

export const Filters: FC<FiltersProps> = ({ isFetching }) => {
  const orderByKey = useOrderByKey();
  const setOrderKey = useSetOrderBy();
  const setSearchQuery = useSetSearchQuery();
  const { run: handleChangeSearch } = useDebounceFn(setSearchQuery, { wait: 300 });

  return (
    <Flex justify="space-between" align="center" style={{ marginBottom: '20px', marginTop: 20 }}>
      <Select
        loading={isFetching}
        style={{ width: '200px' }}
        defaultValue="recent"
        onChange={setOrderKey}
        value={orderByKey}
        options={[
          { value: 'recent', label: 'Most recent upload' },
          { value: 'oldest', label: 'Oldest upload' },
          { value: 'az', label: '(A-Z) alphabetical' },
          { value: 'za', label: '(Z-A) alphabetical' },
        ]}
      />
      <Input.Search
        placeholder="Search files"
        onChange={(e) => handleChangeSearch(e.target.value)}
        style={{ width: '200px' }}
        allowClear
      />
    </Flex>
  );
};
